var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      directives: [{ name: "key2click", rawName: "v-key2click" }],
      class: _vm.question.getChooseFileCss(),
      attrs: {
        tabindex: "0",
        for: _vm.question.inputId,
        "aria-label": _vm.question.chooseButtonText,
      },
      on: {
        click: function (event) {
          _vm.question.chooseFile(event)
        },
      },
    },
    [
      _vm.question.cssClasses.chooseFileIconId
        ? _c("sv-svg-icon", {
            attrs: {
              title: _vm.question.chooseButtonText,
              iconName: _vm.question.cssClasses.chooseFileIconId,
              size: "auto",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.question.chooseButtonText))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }